import React from 'react'
import {
  getBatteryImageSrc,
  getBatteryPercentageText,
} from '../../helpers/batteryHelper'
import './BatteryRemaining.css'

type Props = {
  percentage?: number | null
}

const BatteryRemaining = ({ percentage }: Props) => (
  <div className="battery-remaining">
    <img
      className="battery-remaining-icon"
      src={getBatteryImageSrc(percentage)}
      alt="battery"
    />
    <span className="battery-remaining-percentage">
      {getBatteryPercentageText(percentage)}
    </span>
  </div>
)

export default BatteryRemaining
